<script setup>
import { ref, watch } from "vue";
import { Head, Link, router } from "@inertiajs/vue3";
import debounce from "lodash/debounce";

import Datatables from "@/Shared/Tables/Datatables.vue";
import DatatableFooterWrapper from "@/Shared/Tables/DatatableFooterWrapper.vue";

import VAlert from "@/Shared/VAlert.vue";

import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VButtonCreate from "@/Shared/HeaderButton/VButtonCreate";

let props = defineProps({
    title: String,
    additional: Object
});

const breadcrumbs = [
    {
        url: "#",
        label: "Questionnaire",
    },
];

const changePageLength = (value) => {
    getSurveyTemplate({ per_page: value });
};

const changeOrder = (value) => {
    getSurveyTemplate({
        search_fields: value.search_fields,
        search_values: value.search_values,
        per_page: props.additional.filters.per_page ?? 20,
        order_by: value.order_by,
        order_type: value.order_type,
    });
};

const getSurveyTemplate = (params) => {
    router.get("/questionnaire", params, {
        preserveState: true,
        replace: true,
    });
};
</script>

<template>
    <Head>
        <title>Questionnaire</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <VAlert />

        <div class="card">
            <div class="card-body">
                <div class="text-end mb-3">
                    <!-- <VButtonCreate :href="additional.urlCreate"> Add Country </VButtonCreate> -->
                </div>

                <div class="dataTables_wrapper dt-bootstrap5">
                    <Datatables
                        :columns="additional.columns"
                        :pagination="additional.survey"
                        :filters="additional.filters"
                        @onFilter="changeOrder"
                    />

                    <DatatableFooterWrapper
                        :pagination="additional.survey.meta"
                        :filters="additional.filters"
                        @onChange="changePageLength"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
